import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  components: {
    Button: {
      baseStyle: {
        _hover: {
          bg: "#FFD8D8",
          color: "black",
        },
      },
    },
  },
});

export default theme;
